import { JetView } from 'webix-jet';
import { devConfig, profile } from 'config/config';

/**
 * Class representing the FilterProductsThirdQuotaView.
 * @extends JetView
 */
export default class FilterProductsThirdQuotaView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'combo',
                            name: 'ProductsThird',
                            id: 'ProductsThird',
                            label: _('Producto Tercero'), // Label for the combo
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'checkbox',
                            label: _('Ver cupos asignados a puntos de venta'), // Checkbox label
                            labelPosition: 'top',
                            name: 'IsDetails',
                            id: 'IsDetails',
                            value: 0, // Default value
                        },
                        { gravity: 1, id: 'grav' }, // Gravity for layout
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    id: 'BetShopId',
                    cols: [
                        {
                            view: 'combo',
                            name: 'BetShopId',
                            label: "<span class='icon-shop'></span>" + _('Punto de Venta'), // Label with icon
                            hidden: !devConfig.getPermAction('filterByBetShop', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByBetShop',
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        var vthis = this; // Reference to the current context
                                        if (text.length > 2) {
                                            // Trigger data fetch if input length is greater than 2
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/BetShopsSelect',
                                                    '{"Filter":"' + text + '"}', // Request body
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message(
                                                                'Error! ', // Error message on failure
                                                            );
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(
                                                                text, // Parse response
                                                            );
                                                            if (
                                                                !resp.HasError // Check for errors in response
                                                            ) {
                                                                vthis.parse(
                                                                    resp.Data, // Populate combo with data
                                                                );
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        { gravity: 1, id: 'grav2' }, // Gravity for layout
                        { gravity: 1, id: 'grav3' }, // Gravity for layout
                    ],
                },
            ],
        };

        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left], // Include left section
                },
            ],
        };

        const buttons = {
            margin: 5,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Agregar cupo'), // Button label
                    type: 'form',
                    autowidth: true,
                    hidden: !devConfig.getPermAction('accountingQuotaAdd', 'Add'), // Conditional visibility based on permissions
                    css: 'prm-accountingQuotaAdd',
                    click: () => {
                        this.app.callEvent('addQuota:button', [{}]); // Event call on button click
                    },
                },
                {
                    view: 'button',
                    value: _('Limpiar'), // Button label
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clear form on button click
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Button label
                    hotkey: 'enter', // Hotkey for the button
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('ProductsThird:filter', [
                            filterdata, // Event call with filter data
                        ]);
                    },
                },
            ],
        };

        return {
            view: 'form',
            rows: [upper_section, buttons], // Form layout
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     */
    init() {
        $$('BetShopId').hide(); // Initially hide BetShopId combo
        $$('IsDetails').attachEvent('onChange', function (newv, oldv) {
            if ($$('IsDetails').getValue() == '0') {
                // Check checkbox value
                $$('BetShopId').hide(); // Hide BetShopId if checkbox is unchecked
                $$('grav2').hide(); // Hide gravity elements
                $$('grav3').hide(); // Hide gravity elements
            } else {
                $$('BetShopId').show(); // Show BetShopId if checkbox is checked
                $$('grav2').show(); // Show gravity elements
                $$('grav3').show(); // Show gravity elements
            }
        });

        webix.ready(function () {
            if (screen.width < 500) {
                // Responsive behavior for small screens
                $$('grav').hide(); // Hide gravity elements
                $$('grav2').hide(); // Hide gravity elements
                $$('grav3').hide(); // Hide gravity elements
            }
        });

        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(
                devConfig.geturlApi() + 'Accounting/GetProductsThirdQuotaSelect',
                '', // Empty request body
                {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message(_('Error! ')); // Error message on failure
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var resp = JSON.parse(text); // Parse response
                        $$('ProductsThird').define('options', resp.Data); // Define options for ProductsThird combo
                        $$('ProductsThird').refresh(); // Refresh combo to show new options
                    },
                },
            );
    }
}

// FILE DOCUMENTED
